import { DataModel } from "common/models/utility-models/base-model";
import { GridModel } from "common/models/utility-models/list-utility.model";

export class studentAssignmentModel extends DataModel {
    attended_flag: number = 0;
    studentUploadedFile: any;
    file_flag: any;
    assignment_id: number = 0;
    assignment_name: string = '';
    trainer_id: any;
    timeslot_id: any;
    type_name: string = '';
    start_date: any;
    end_date: any;
    upload_assignment_flag: any;
    assignment_upload_document: any;

}

export class studentAssignmenListingtModel extends GridModel<studentAssignmentModel> {

}